module.exports = __webpack_public_path__ + "media/images/digital2-b9ea0914d08561142fa46b2a1efa18f4.png";